import React, { useState } from "react";
import { Card, CardContent } from "../../ui/card";
import { Headline, PainBanner, Pill, SectionTitle } from "./PersonaUi";
import { EARN_DETAIL, EARN_WEEK, EVIDENCE } from "./personaData";

const CHIP = { GREEN: "border-emerald-500/50 bg-emerald-500/10 text-emerald-300", RED: "border-red-500/50 bg-red-500/10 text-red-300", neutral: "border-border bg-muted/20 text-foreground/80" };
const CLASSES = [["Clean setups (0 flags)", "+73 bp", "text-emerald-400"], ["1–2 flags", "+11 bp", ""], ["RED (3+ flags)", "−43 bp", "text-red-400"]];

export default function HfEarningsWeek() {
  const [sel, setSel] = useState("GRMN");
  const all = Object.values(EARN_WEEK).flat();
  const d = EARN_DETAIL[sel];
  const st = all.find((x) => x.sym === sel)?.s;
  return (
    <div className="space-y-4" data-testid="persona-hf-earnings">
      <PainBanner testid="persona-hf-earnings-pain" persona="HF ANALYST · EARNINGS-WEEK PLANNER"
        pain="15 prints in my coverage next week — where is the positioning edge, and which ones should I not be long into?"
        answer="week grid coloured by setup, checklist on click" />
      <Headline testid="hf-earnings-headline">Week of Oct 26 · {all.length} prints · {all.filter((x) => x.s === "GREEN").length} GREEN · {all.filter((x) => x.s === "RED").length} RED · 1 qualified Earnings Alpha trade</Headline>
      <Card><CardContent className="pt-4">
        <div className="grid grid-cols-5 gap-3" data-testid="hf-earnings-week-grid">
          {Object.entries(EARN_WEEK).map(([day, list]) => (
            <div key={day} className="space-y-2">
              <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground border-b border-border pb-1">{day}</div>
              {list.map((x) => (
                <button key={x.sym} onClick={() => EARN_DETAIL[x.sym] && setSel(x.sym)} data-testid={`hf-earnings-chip-${x.sym}`}
                  className={`w-full text-left rounded border px-2.5 py-2 transition-colors ${CHIP[x.s]} ${sel === x.sym ? "ring-1 ring-sky-400" : ""} ${EARN_DETAIL[x.sym] ? "cursor-pointer" : "cursor-default opacity-80"}`}>
                  <div className="flex items-center justify-between"><span className="font-mono font-bold text-sm">{x.sym}</span><span className="text-[9px] font-mono uppercase">{x.t}</span></div>
                  <div className="text-[10px] mt-0.5">{x.s === "neutral" ? "no edge" : x.s}{x.sym === "NOW" ? " · EA TRADE" : ""}</div>
                </button>
              ))}
            </div>
          ))}
        </div>
      </CardContent></Card>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
        <Card className="xl:col-span-2" data-testid="hf-earnings-detail"><CardContent className="pt-4">
          <SectionTitle right={<Pill tone={st === "RED" ? "bad" : "good"}>{st}</Pill>}>{sel} — setup into the print</SectionTitle>
          <table className="w-full text-xs" data-testid="hf-earnings-flags-table">
            <tbody>
              {d.flags.map(([k, on]) => (
                <tr key={k} className="border-b border-border/40">
                  <td className="py-1.5 px-2">{k}</td>
                  <td className={`py-1.5 px-2 text-right font-mono ${on ? "text-red-400" : "text-muted-foreground"}`}>{on ? "● flagged" : "○ clear"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3 text-[11px]">
            <div><div className="text-muted-foreground">Red flags</div><div className="font-mono text-lg font-bold">{d.flags.filter((f) => f[1]).length} / 5</div></div>
            <div><div className="text-muted-foreground">Earnings Alpha</div><div>{d.ea}</div></div>
            <div><div className="text-muted-foreground">Last 4 day-of moves</div><div className="font-mono">{d.last4}</div></div>
          </div>
        </CardContent></Card>
        <Card data-testid="hf-earnings-classes"><CardContent className="pt-4">
          <SectionTitle>What a setup class has meant (OOS)</SectionTitle>
          {CLASSES.map(([k, v, c]) => (
            <div key={k} className="flex justify-between border-b border-border/40 py-2 text-[13px]"><span className="text-muted-foreground">{k}</span><span className={`font-mono font-bold ${c}`}>{v}</span></div>
          ))}
          <div className="text-[10px] text-muted-foreground mt-3 space-y-1">
            <div>{EVIDENCE.red}.</div><div>{EVIDENCE.green}.</div>
            <div>This is earnings-day <b>drift</b> positioning — it does not predict EPS beats or misses (tested, IC ≈ 0) and does not flag big-miss tails.</div>
          </div>
        </CardContent></Card>
      </div>
    </div>
  );
}
